<p-floatLabel>
  <p-autoComplete [suggestions]="users" (completeMethod)="searchUser($event.query)" field="Id"
    (onSelect)="onSelectionChanged.emit($event.value)" [forceSelection]="true" [showClear]="true"
    (onClear)="onSelectionChanged.emit()">
    <ng-template let-user pTemplate="item">
      <div class="flex align-items-center gap-2">
        <img [src]="user.Profile?.ImageUrl" style="width: 18px" />
        <div>{{user.Profile?.Name}}</div>
        <div>[{{user.Identity?.Email || (user.Identity?.PhoneNumber|phone)}}]</div>
      </div>
    </ng-template>
  </p-autoComplete>
  <label>User</label>
</p-floatLabel>